
export class Utilities {
    public static readonly FORMAT_FULL_DATETIME = 'DD/MM/yyyy hh:mm:ss A';
    public static readonly FORMAT_FULL_DATE = 'DD/MM/yyyy';
    public static readonly DEFAULT_TIMEZONE = 'Australia/Sydney';
    public static readonly STR_YES = 'Yes';
    public static readonly STR_NO = 'No';
    public static readonly STR_FULL = 'full';
    public static readonly STR_SLIDER = 'slider';
    public static readonly STR_PAGE_KEY = 'pageKey';
    public static readonly STR_FORM = 'form';
    public static readonly STR_LIST = 'list';
    public static readonly STR_TOOLBAR = 'toolbar';
    public static readonly STR_CONTROLS = 'controls';
    public static readonly EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
    public static readonly EMPTY_NEW = 'new';
    public static readonly SAVED_MSG = 'Record has been successfully saved.';
    public static readonly UPDATED_MSG = 'Record has been successfully updated.';
}
export const DateTimeFormation: any = {
    FORMAT_FULL_DATETIME: 'DD/MM/yyyy HH:mm:ss',
    FORMAT_FULL_DATETIME_EXT: 'dd-MM-yyyy HH:mm:ss',
}

export const AuditAction: any = {
    create: 1,
    update: 2,
    delete: 3,
    approve: 5,
    reject: 6,
    requesterComment: 7,
    approverComment: 8,
    complete: 9,
    autoEscalated: 10,
    approver: 11,
    requester: 12,
    moveNext: 13,
    cancel: 14,
    rejectComment: 15,
}